exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Adjust modal edges */\r\ndiv.ui-widget-overlay {\r\n    height: calc(100%);\r\n    width: calc(100% - 14px);\r\n    margin-top: -7px;\r\n    margin-left: 7px;\r\n}\r\n\r\n\r\n.ui-dialog-titlebar.ui-widget-header, .ui-dialog-titlebar .ui-button {\r\n    background: transparent;\r\n    border-style: none\r\n}\r\n\r\n.ui-widget-overlay {\r\n    position: absolute;\r\n    opacity: 0.5;\r\n}\r\n/*\r\n.modal-body {\r\n    height: 90% !important;\r\n}\r\n.modal-footer {\r\n    height: 10% !important;\r\n}\r\n    */\r\n", ""]);

// exports
